import React from 'react';
import Layout from '../../components/Shared/Layout';
import SWVL from '../../components/Portfolio/swvl';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class SWVLPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/swvl',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <SWVL />
      </Layout>
    );
  }
}

export default SWVLPage;
